

import React from 'react';
import { NoEditModeBlock } from '../../Blocks/components/common/StyledEditables';

const NoEditMode = ({ className = '' }) =>
<NoEditModeBlock className={className}>
    This Element can not be modified
  </NoEditModeBlock>;


export default NoEditMode;